var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 11",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.125.621 5.63 5.713c.257.293.623.44 1.026.44s.77-.184 1.026-.44L12.077.694l.11-.11c-.146-.073-.366-.11-.586-.11h-9.89c-.22 0-.403.037-.586.147Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.883 1.207c-.037.037-.037.11-.074.147L8.377 6.372c-.44.513-1.062.77-1.722.77-.659 0-1.282-.294-1.721-.77L.428 1.244s0-.037-.036-.037c-.147.256-.22.513-.22.806v6.923c0 .842.696 1.538 1.538 1.538h9.89c.843 0 1.539-.696 1.539-1.538V2.013c0-.293-.11-.586-.256-.806Z"
  })));
};

export default SvgEmail;